var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: "#AD88C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8841 12.2H10.6721L9.85612 9.89605H6.12412L5.29612 12.2H4.12012L7.28812 3.80005H8.77612L11.8841 12.2ZM7.38412 6.38005L6.47212 8.91205H9.49612L8.59612 6.38005C8.36812 5.73205 8.24812 5.26405 8.23612 4.55605H7.75612C7.73212 5.26405 7.62412 5.73205 7.38412 6.38005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallAudit);
export default __webpack_public_path__ + "static/media/small-audit.e3e945d301a312c017f666b70cc4cc53.svg";
export { ForwardRef as ReactComponent };